/**
 * InlineSpinner component module.
 * @module shared/components/InlineSpinner
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {fill, secondaryImportanceButton} from './cssUtils';

const getSpinnerSize = (props) => {
  if (props.size === 'lg') {
    return '14px';
  }
  if (props.size === 'md') {
    return '10px';
  }
  if (props.size === 'sm') {
    return '8px';
  }
};

const getColor = (props) => {
  if (props.importance === 'primary') {
    return '#FFFFFF';
  }
  if (props.importance === 'secondary') {
    return secondaryImportanceButton(props).color;
  }
};

const _InlineSpinner = styled.span`
  margin: 0 auto 0;
  ${fill()};
  text-align: center;

  & > div {
    width: ${props => getSpinnerSize(props)};
    height: ${props => getSpinnerSize(props)};
    background-color: ${props => getColor(props)};
    vertical-align: middle;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  & .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  & .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0)
    }
    40% {
      -webkit-transform: scale(1.0)
    }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }
`;

const InlineSpinner = ({size = 'sm', importance = 'primary'}) => <_InlineSpinner size={size} importance={importance}>
  <div className='bounce1'/>
  <div className='bounce2'/>
  <div className='bounce3'/>
</_InlineSpinner>;

export default InlineSpinner;

InlineSpinner.propTypes = {
  /**
   * Button level of importance. Defaults to primary.
   */
  importance: PropTypes.oneOf(['primary', 'secondary']),
  /**
   * Button size. Defaults to sm.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};
